import { SxProps, Theme } from "@mui/material/styles";
import theme from "src/themes";
import GoBadge from "./GoBadge";

const CoreBadge = ({ sx }: { sx?: SxProps<Theme> }) => {
    const { core } = theme.palette.badge;
    return (
        <GoBadge
            label="CORE"
            textColor={core.text}
            backgroundColor={core.background}
            borderColor={core.border}
            sx={sx}
        />
    );
};

export default CoreBadge;
